var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[(_vm.diskConfig)?_c('VueUploader',{attrs:{"input-name":_vm.inputName,"images":_vm.images,"max-photos":_vm.maxPhotos,"disk-config":_vm.diskConfig,"form-type":_vm.formType},model:{value:(_vm.oldFiles),callback:function ($$v) {_vm.oldFiles=$$v},expression:"oldFiles"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }